import { Text } from '@shared/components/Text';
import { AddressField } from '@shared/data/entity/fields/AddressField';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';

interface Props {
  field: AddressField;
}

export function AddressCollectionViewField({ field }: Props) {
  if (field.isEmpty) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer fieldType={field.fieldType}>
      <Text size="body1">{field.address.title}</Text>
      <Text size="body1" inactive>
        {field.address.subtitle}
      </Text>
    </CardCollectionViewFieldContainer>
  );
}
